export default function mapFormToBroker(formValues, country) {
  return {
    ...formValues,
    broker: {
      firstName: formValues.brokerFirstName,
      lastName: formValues.brokerLastName,
      email: formValues.brokerEmail,
      companyName: formValues.brokerCompany,
      mobilePhone: '',
      country,
    },
    isBroker: true,
  }
}
